<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.9941 2.4751C17.2498 2.47551 21.5106 6.73692 21.5107 11.9927C21.5105 17.2484 17.2498 21.5089 11.9941 21.5093C6.73814 21.5093 2.47681 17.2486 2.47656 11.9927C2.47674 6.73667 6.73809 2.4751 11.9941 2.4751ZM11.9941 3.9751C7.56652 3.9751 3.97674 7.5651 3.97656 11.9927C3.97681 16.4202 7.56656 20.0093 11.9941 20.0093C16.4214 20.0089 20.0105 16.4199 20.0107 11.9927C20.0106 7.56535 16.4214 3.97551 11.9941 3.9751ZM12.7422 16.1538H11.2422V11.731H12.7422V16.1538ZM12.7422 9.33447H11.2422V7.8335H12.7422V9.33447Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
